// _shared/hooks/useInfo.js
import { useState, useEffect, useRef } from 'react';
import { infoService } from '../../_services/infoService';

export const useInfo = (slug) => {
  const [editMode, setEditMode] = useState('visual');
  const [htmlContent, setHtmlContent] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfFile, setPdfFile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const hasFetched = useRef(false);

  // ==========================================
  // 📥 CARGAR DATOS INICIALES (BLINDADO)
  // ==========================================
  useEffect(() => {
    const fetchData = async () => {
      if (!slug || hasFetched.current) return;
      setIsLoading(true);
      try {
        // infoService.getInfo ahora devuelve DIRECTAMENTE { type, content }
        const data = await infoService.getInfo(slug);

        if (data?.type === 'pdf') {
          setEditMode('pdf');
          setPdfUrl(data.content || '');
        } else {
          setEditMode('visual');
          // 🔥 AQUÍ ESTABA EL ERROR: Forzamos a que sea un string limpio
          setHtmlContent(typeof data?.content === 'string' ? data.content : '');
        }
        hasFetched.current = true;
      } catch (err) {
        console.error('Error al cargar info:', err);
        setError('No se pudo cargar la información');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [slug]);

  // ==========================================
  // 💾 GUARDAR
  // ==========================================
  const handleSave = async () => {
    if (!slug) {
      setError('Error: slug no definido');
      return false;
    }

    setIsSaving(true);
    setError(null);

    try {
      if (editMode === 'pdf') {
        if (!pdfFile && !pdfUrl) {
          setError('Debes seleccionar un archivo PDF');
          return false;
        }
        if (pdfFile) {
          await infoService.uploadPdf(slug, pdfFile);
          setPdfFile(null);
        }
      } else {
        // Enviamos el string HTML limpio
        await infoService.saveHtml(slug, htmlContent);
      }
      return true;
    } catch (err) {
      console.error('Error al guardar:', err);
      setError(err.response?.data?.message || err.message || 'Error al guardar');
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  const changeMode = (newMode) => setEditMode(newMode);
  const openPreview = () => setShowPreview(true);
  const closePreview = () => setShowPreview(false);

  const handleDeletePdf = async () => {
    if (!pdfUrl) return;
    if (!window.confirm('¿Eliminar el PDF actual?')) return;
    
    try {
      const filename = pdfUrl.split('/').pop();
      await infoService.deleteFile(slug, filename);
      setPdfUrl('');
      setPdfFile(null);
    } catch (err) {
      console.error('Error al eliminar PDF:', err);
      setError('No se pudo eliminar el PDF');
    }
  };

  return {
    editMode, htmlContent, pdfUrl, pdfFile, isSaving, isLoading, error, showPreview,
    setHtmlContent, setPdfFile, changeMode, handleSave, handleDeletePdf, openPreview, closePreview, setError,
  };
};